import Chip, { ChipSize, ChipVariant } from "@galaxy-io/dls/chips/Chip";
import type { ActivityItem } from "@gtm/contracts";
import { signalLabel } from "@gtm/contracts";
import { ChatCircleIcon, CircleIcon, EyeIcon, GitForkIcon, StarIcon } from "@phosphor-icons/react";
import type { ComponentProps } from "react";

export function activityIcon(type: ActivityItem["type"]) {
  return type === "star"
    ? StarIcon
    : type === "comment"
      ? ChatCircleIcon
      : type === "fork"
        ? GitForkIcon
        : type === "watcher"
          ? EyeIcon
          : CircleIcon;
}

export function ActivitySignalChip({
  activity,
  size = ChipSize.MEDIUM,
  onClick,
}: {
  activity: Pick<ActivityItem, "type" | "kind" | "baseline" | "signal">;
  size?: ChipSize;
  onClick?: ComponentProps<typeof Chip>["onClick"];
}) {
  const { type, kind, baseline } = activity;
  return (
    <Chip
      size={size}
      onClick={onClick}
      label={signalLabel(activity)}
      icon={activityIcon(type)}
      {...(type === "fork" ||
      type === "star" ||
      type === "issue" ||
      type === "comment" ||
      type === "post"
        ? {
            color:
              type === "fork" && kind === "removed"
                ? "pink"
                : type === "fork" && baseline
                  ? "purple"
                  : type === "star"
                    ? "yellow"
                    : type === "issue"
                      ? "purple"
                      : type === "comment"
                        ? "blue"
                        : type === "fork"
                          ? "teal"
                          : type === "post"
                            ? "lime"
                            : "lime",
          }
        : { variant: ChipVariant.SECONDARY })}
    />
  );
}
